import Image from "next/future/image";

const Emoji = ({ src, className = "" }) => {
  return (
    <div className={className}>
      <Image src={src} alt="emoji image" loading="lazy" priority={false} />
    </div>
  );
};

export default Emoji;
